import { defineStore } from 'pinia';

export const useVertragStore = defineStore('vertrag', {
    state: () => ({
        // Vertragsdaten
        vertragsnummer: '',
        secretstring: '',
        
        // Status
        isSubmitting: false,
        hasSubmit: false,
        errorMessage: '',
    }),
    
    getters: {
        /**
         * Prüft ob der Vertragsabschluss abgeschlossen wurde
         * @returns {boolean}
         */
        isSubmitComplete: (state) => {
            return state.hasSubmit;
        },
        
        /**
         * Prüft ob ein Fehler vorliegt
         * @returns {boolean}
         */
        hasError: (state) => {
            return state.errorMessage !== '';
        },
    },
    
    actions: {
        /**
         * Setzt den Store zurück
         */
        resetVertrag() {
            console.log('[VertragStore] Store wird zurückgesetzt');
            this.vertragsnummer = '';
            this.secretstring = '';
            this.isSubmitting = false;
            this.hasSubmit = false;
            this.errorMessage = '';
        },
        
        /**
         * Löscht nur die Fehlerinformationen
         */
        resetError() {
            this.errorMessage = '';
        },
    },
    
    persist: {
        storage: sessionStorage
    }
});
